import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ee0b294c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0b294c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee0b294c')) {
      api.createRecord('ee0b294c', component.options)
    } else {
      api.reload('ee0b294c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ee0b294c&scoped=true&", function () {
      api.rerender('ee0b294c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sq3CvAhtDUsr/JS/comp/Accordion.vue"
export default component.exports